export const DATA_QA_ATTR_PREFIX = 'resumes-countries-visibility-settings';

export type CountrySelection = 'common' | 'uzbekistan';
export type DataQaKey = 'modal' | 'page';
